import { Http } from "@Services";
import { ITextFieldCollection, ITextFieldSubmission } from "@Interfaces";

export interface CreatePollTextFieldRequest {
    channel_id: string;
    question: string;
    placeholder?: string;
    required?: boolean;
    maxLength?: number;
    rows?: number;
}

export interface CreatePollTextFieldResponse {
    success: boolean;
    data: ITextFieldCollection;
}

export const postPollTextField = async (
    payload: CreatePollTextFieldRequest
): Promise<CreatePollTextFieldResponse> => {
    return Http.Request<CreatePollTextFieldResponse>({
        method: "POST",
        url: "/poll-text-fields",
        data: payload,
    });
};

export const getPollTextFieldSubmissions = async (
    pollTextFieldId: string
): Promise<{ success: boolean; data: ITextFieldSubmission[] }> => {
    return Http.Request<{ success: boolean; data: ITextFieldSubmission[] }>({
        method: "GET",
        url: `/poll-text-fields/${pollTextFieldId}/submissions`,
    });
};

export const getPollTextFields = async (
    channelId: string
): Promise<{ success: boolean; data: ITextFieldCollection[] }> => {
    return Http.Request<{ success: boolean; data: ITextFieldCollection[] }>({
        method: "GET",
        url: `/poll-text-fields/${channelId}`,
    });
};

export interface SubmitPollTextFieldRequest {
    response: string;
    metadata?: Record<string, unknown>;
    poll_id?: string;
}

export interface SubmitPollTextFieldResponse {
    success: boolean;
}

export const postPollTextFieldSubmission = async (
    pollTextFieldId: string,
    payload: SubmitPollTextFieldRequest
): Promise<SubmitPollTextFieldResponse> => {
    return Http.Request<SubmitPollTextFieldResponse>({
        method: "POST",
        url: `/poll-text-fields/${pollTextFieldId}/submissions`,
        data: payload,
    });
};

export interface UpdatePollTextFieldRequest {
    question: string;
}

export interface UpdatePollTextFieldResponse {
    success: boolean;
}

export const updatePollTextField = async (
    pollTextFieldId: string,
    payload: UpdatePollTextFieldRequest
): Promise<UpdatePollTextFieldResponse> => {
    return Http.Request<UpdatePollTextFieldResponse>({
        method: "PATCH",
        url: `/poll-text-fields/${pollTextFieldId}`,
        data: payload,
    });
};

export const deletePollTextField = async (
    pollTextFieldId: string
): Promise<void> => {
    return Http.Request<void>({
        method: "DELETE",
        url: `/poll-text-fields/${pollTextFieldId}`,
    });
};
